export default __webpack_public_path__ + "static/media/acesso-negado.a2cfe0e2.png";